// import React from "react";
// import "../css/LoanClosureReport.css";
// import timelineImage from "../assets/h2.png"; // A creative loan/clock/timeline image

// const LoanClosureReport = () => {
//   return (
//     <div className="LoanClosureReport-wrapper">
//       <div className="LoanClosureReport-leftPanel">
//         <h1 className="LoanClosureReport-title">Loan Closure Report</h1>
//         <p className="LoanClosureReport-message">
//           📊 This page is under development.
//         </p>
//         <p className="LoanClosureReport-message">
//           Soon, you will be able to monitor all closed loans, track pre-closures, 
//           see outstanding balances, and visualize closure timelines.
//         </p>
//         <p className="LoanClosureReport-message">
//           Powerful features like progress tracking, overdue alerts, and closure statistics are on the way!
//         </p>

//         <div className="LoanClosureReport-progress">
//           <div className="progress-bar complete">
//             <span>Closed Loans</span>
//           </div>
//           <div className="progress-bar pending">
//             <span>Pending Closure</span>
//           </div>
//           <div className="progress-bar alert">
//             <span>Overdue</span>
//           </div>
//         </div>

//         <div className="LoanClosureReport-flashingText">
//           🔔 LOAN CLOSURE DASHBOARD COMING SOON
//         </div>
//       </div>

//       <div className="LoanClosureReport-rightPanel">
//         <img
//           src={timelineImage}
//           alt="Loan Timeline"
//           className="LoanClosureReport-image"
//         />
//       </div>
//     </div>
//   );
// };

// export default LoanClosureReport;




// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchLoanReports, deleteLoan } from "../redux/slices/loanReportSlice";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "../css/LoanReport.css";
// import axios from "axios";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];

// const API_URL = "https://payyug.in/api/"; 

// const LoanClosureReport = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const { loans, loading, error } = useSelector((state) => state.loanReport);

//   const [filterData, setFilterData] = useState({
//     fromDate: "",
//     toDate: "",
//     loanAccountNumber: "",
//     userId: "",
//     userName: "",
//     loanStatus: "",
//   });

//   const [filteredLoans, setFilteredLoans] = useState([]);
//   const [showConfirmDialog, setShowConfirmDialog] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   useEffect(() => {
//     dispatch(fetchLoanReports());
//   }, [dispatch]);

//   useEffect(() => {
//     setFilteredLoans(loans);
//     setCurrentPage(1);
//   }, [loans]);

//   useEffect(() => {
//     if (error) {
//       toast.error(`Error: ${error}`);
//     }
//   }, [error]);

//   const handleChange = (e) => {
//     setFilterData({ ...filterData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const filtered = loans.filter((loan) => {
//       const {
//         fromDate,
//         toDate,
//         loanAccountNumber,
//         userId,
//         userName,
//         loanStatus,
//       } = filterData;
//       const appliedDate = new Date(loan.appliedDate);

//       return (
//         (!fromDate || appliedDate >= new Date(fromDate)) &&
//         (!toDate || appliedDate <= new Date(toDate)) &&
//         (!loanAccountNumber ||
//           loan.loanAccountNumber
//             ?.toLowerCase()
//             .includes(loanAccountNumber.toLowerCase())) &&
//         (!userId || loan.userId?.toString() === userId) &&
//         (!userName ||
//           loan.userName?.toLowerCase().includes(userName.toLowerCase())) &&
//         (!loanStatus || loan.status?.toLowerCase() === loanStatus.toLowerCase())
//       );
//     });

//     setFilteredLoans(filtered);
//     setCurrentPage(1);
//   };

//   const handleApproveLoan = async (loan) => {
//     console.log("➡️ Approve Loan button clicked");
//     console.log("Loan ID:", loan.id);
//     console.log("Current Loan Status:", loan.status);

//     if (loan.status === "Approved" || loan.status === "disbursed") {
//       console.info(`⚠️ Loan is already ${loan.status}, skipping approval.`);
//       toast.info(`Loan is already ${loan.status}`);
//       return;
//     }

//     try {
//       console.log("🔧 Sending approve loan API request...");
//       const response = await axios.post(
//         `${API_URL}approveLoan-personal/${loan.id}/approve`,
//         { approvalRemark: "Verified documents" }
//       );

//       console.log("✅ API Response:", response.data);
//       toast.success(response.data.message);

//       dispatch(fetchLoanReports());
//     } catch (error) {
//       console.error("🚨 Loan Approval Error:", error);
//       toast.error(error.response?.data?.message || "Failed to approve loan");
//     }
//   };

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "N/A";
//     const date = new Date(dateStr);
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
//       2,
//       "0"
//     )}-${String(date.getDate()).padStart(2, "0")} ${String(
//       date.getHours()
//     ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
//   };

//   const totalPages = Math.ceil(filteredLoans.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentLoans = filteredLoans.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="LoanReport-container">
//       {/* Filter Section */}
//       <section className="LoanReport-filterSection">
//         <h2 className="LoanReport-title">Loan Report Filter</h2>
//         <p className="LoanReport-subtitle">
//           Use filter to see more precise report
//         </p>
//         <form className="LoanReport-form" onSubmit={handleSubmit}>
//           <div className="LoanReport-grid">
//             {/* <div className="LoanReport-formGroup">
//               <label>From Date</label>
//               <input type="date" name="fromDate" onChange={handleChange} />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>To Date</label>
//               <input type="date" name="toDate" onChange={handleChange} />
//             </div> */}
//             <div className="LoanReport-formGroup">
//               <label>Loan Account Number</label>
//               <input
//                 type="text"
//                 name="loanAccountNumber"
//                 placeholder="Loan account number"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Applicant User ID</label>
//               <input
//                 type="text"
//                 name="userId"
//                 placeholder="Applicant user id"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="LoanReport-formGroup">
//               <label>Applicant User Name</label>
//               <input
//                 type="text"
//                 name="userName"
//                 placeholder="Applicant user name"
//                 onChange={handleChange}
//               />
//             </div>
//             {/* <div className="LoanReport-formGroup">
//               <label>Choose Loan Status</label>
//               <select name="loanStatus" onChange={handleChange}>
//                 <option value="">Select loan status</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Approved">Approved</option>
//                 <option value="Rejected">Rejected</option>
//                 <option value="Closed">Closed</option>
//               </select>
//             </div> */}
//           </div>
//           <button type="submit" className="LoanReport-submitBtn">
//             Submit
//           </button>
//         </form>
//       </section>

//       {/* Loan Details Section */}
//       <section className="LoanReport-detailsSection">
//         <div className="LoanReport-tableHeader">
//           <div>
//             <label>Show </label>
//             <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
//               {ITEMS_PER_PAGE_OPTIONS.map((count) => (
//                 <option key={count} value={count}>
//                   {count}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//           <input
//             type="text"
//             placeholder="Search..."
//             className="LoanReport-searchInput"
//           />
//         </div>

//         <div className="LoanReport-tableContainer">
//           <table className="LoanReport-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Loan ID</th>
//                 <th>Borrower Name</th>
//                 <th>Loan Amount</th>
//                 <th>Interest Amount</th>
//                 <th>Loan Tenure</th>
//                 <th>Loan Frequency</th>
//                 <th>Applied Date</th>
//                 <th>Approval Date</th>
//                 <th>Disbursal Date</th>
//                 <th>Loan Status</th>
//                 <th>EMI Amount</th>
//                 <th>Total Payable</th>
//                 <th>Loan Type</th>
//                 <th>View EMI</th>
//                 <th>Loan Card</th>
//                 <th>Loan Status</th>
//                 <th>Approved Action</th>
//                 <th>Disbursement Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="22">Loading...</td>
//                 </tr>
//               ) : error ? (
//                 <tr>
//                   <td colSpan="22">Error: {error}</td>
//                 </tr>
//               ) : currentLoans.length === 0 ? (
//                 <tr>
//                   <td colSpan="22">No data available</td>
//                 </tr>
//               ) : (
//                 currentLoans.map((loan, index) => (
//                   <tr key={loan.id}>
//                     <td>{startIndex + index + 1}</td>
//                     <td>{loan.loanAccountNumber || "N/A"}</td>
//                     <td>{loan.userName || "N/A"}</td>
//                     <td>{loan.loanAmount || "N/A"}</td>
//                     <td>{loan.loanInterest || "N/A"}</td>
//                     <td>{loan.loanTenure || "N/A"}</td>
//                     <td>{loan.loanRecoveryFrequency || "N/A"}</td>
//                     <td>{formatDate(loan.loanAppliedDate)}</td>
//                     <td>{formatDate(loan.firstEmiDate)}</td>
//                     <td>{formatDate(loan.disbursalDate)}</td>
//                     <td>{loan.status || "N/A"}</td>
//                     <td>{loan.loanEmiAmount || "N/A"}</td>
//                     <td>{loan.loanPayable || "N/A"}</td>
//                     <td>{loan.loanType || "N/A"}</td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//                       >
//                         View EMI
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         onClick={() => navigate(`/LoanCardPage/${loan.id}`)}
//                       >
//                         Loan Card
//                       </button>
//                     </td>
//                     <td>{loan.status || "N/A"}</td>

//                     {/* Approved Action */}
//                     <td>
//                       {loan.status === "PENDING" && (
//                         <button
//                           onClick={() => {
//                             const confirmApprove = window.confirm(
//                               "Do you want to approve this loan?"
//                             );
//                             if (confirmApprove) handleApproveLoan(loan);
//                           }}
//                         >
//                           Approve Loan
//                         </button>
//                       )}
//                       {(loan.status === "Approved" || loan.status === "disbursed") && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
//                       )}
//                     </td>

//                     {/* Disbursement Action */}
//                     <td>
//                       {loan.status === "Approved" && (
//                         <button
//                           onClick={() =>
//                             navigate(`/LoanDisbursement/${loan.id}`, {
//                               state: { selectedLoan: loan },
//                             })
//                           }
//                           style={{
//                             marginLeft: "6px",
//                             background: "#1f8b94ff",
//                             color: "#fff",
//                             padding: "5px 10px",
//                             border: "none",
//                             borderRadius: "4px",
//                           }}
//                         >
//                           Disburse Loan
//                         </button>
//                       )}
//                       {loan.status === "disbursed" && (
//                         <span style={{ color: "green", fontWeight: "bold" }}>✔</span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Controls */}
//         {totalPages > 1 && (
//           <div className="LoanReport-pagination">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         )}
//       </section>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default LoanClosureReport;




import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchLoanReports } from "../redux/slices/loanReportSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/LoanReport.css";
import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { Download, FileTextIcon } from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50,100, "All"];
const API_URL = "https://payyug.in/api/";

const LoanClosureReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loans = [], loading, error } = useSelector(
    (state) => state.loanReport
  );
      const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;


  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    loanAccountNumber: "",
    userId: "",
    userName: "",
  });

  const [filteredLoans, setFilteredLoans] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableStatusFilter, setTableStatusFilter] = useState("");
    const [company, setCompany] = useState(null);


  // Fetch all loans
  useEffect(() => {
    dispatch(fetchLoanReports());
  }, [dispatch]);

  // Apply CLOSED and REQUESTED status filter whenever loans change
  useEffect(() => {
    const filtered = loans.filter(
      (loan) =>
        ["closed", "requested"].includes(loan?.status?.toLowerCase())
    );
    setFilteredLoans(filtered);
    setCurrentPage(1);
  }, [loans]);

  // Show error toast
  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error}`);
    }
  }, [error]);

  const handleChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };

   useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        } else {
          console.error("Failed to fetch company data");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  // Apply additional filters (still only within CLOSED loans)
  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      fromDate,
      toDate,
      loanAccountNumber,
      userId,
      userName,
    } = filterData;

    const filtered = loans
      .filter((loan) => loan?.status?.toLowerCase() === "closed")
      .filter((loan) => {
        const appliedDate = loan?.loanAppliedDate
          ? new Date(loan.loanAppliedDate)
          : null;

        return (
          (!fromDate || (appliedDate && appliedDate >= new Date(fromDate))) &&
          (!toDate || (appliedDate && appliedDate <= new Date(toDate))) &&
          (!loanAccountNumber ||
            loan.loanAccountNumber
              ?.toLowerCase()
              .includes(loanAccountNumber.toLowerCase())) &&
          (!userId || loan.userId?.toString() === userId) &&
          (!userName ||
            loan.userName
              ?.toLowerCase()
              .includes(userName.toLowerCase()))
        );
      });

    setFilteredLoans(filtered);
    setCurrentPage(1);
  };

const handleItemsPerPageChange = (e) => {
  const val = e.target.value;
  setItemsPerPage(val === "All" ? "All" : Number(val));
  setCurrentPage(1);
};

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  

const filteredByStatusLoans = filteredLoans.filter((loan) =>
  tableStatusFilter
    ? loan?.status?.toLowerCase() === tableStatusFilter.toLowerCase()
    : true
);
const isShowAll = itemsPerPage === "All";
const totalFilteredCount = filteredByStatusLoans.length;
const effectiveItemsPerPage = isShowAll ? totalFilteredCount : Number(itemsPerPage);
const totalPages = isShowAll || totalFilteredCount === 0 
  ? 1 
  : Math.ceil(totalFilteredCount / effectiveItemsPerPage);
const startIndex = isShowAll ? 0 : (currentPage - 1) * effectiveItemsPerPage;
const currentLoans = isShowAll 
  ? filteredByStatusLoans 
  : filteredByStatusLoans.slice(startIndex, startIndex + effectiveItemsPerPage);


         const handleDownloadPDF = async () => {
              const doc = new jsPDF("p", "mm", "a4");
              const pageWidth = doc.internal.pageSize.width;
              const pageHeight = doc.internal.pageSize.height;
          
              // ================= LOGO =================
              const logoX = 15;
              const logoY = 12;
              const logoSize = 25;
              const logoPadding = 2;
          
              // Border color & thickness
              doc.setDrawColor(0);
              doc.setLineWidth(0.2);
          
              // Calculate center of logo
              const centerX = logoX + logoSize / 2;
              const centerY = logoY + logoSize / 2;
          
              // Radius = half of logo + padding
              const radius = logoSize / 2 + logoPadding;
          
              // Draw circle
              doc.circle(centerX, centerY, radius);
          
              // Logo image
              if (company?.logoUrl) {
                try {
                  const logoResp = await fetch(company.logoUrl);
                  const logoBlob = await logoResp.blob();
                  const reader = new FileReader();
                  await new Promise((resolve) => {
                    reader.onload = () => {
                      doc.addImage(
                        reader.result,
                        "PNG",
                        logoX,
                        logoY,
                        logoSize,
                        logoSize,
                      );
                      resolve();
                    };
                    reader.readAsDataURL(logoBlob);
                  });
                } catch {
                  // silent fail
                }
              }
          
              // ================= COMPANY NAME (AUTO WRAP) =================
              doc.setFont("helvetica", "bold");
              doc.setFontSize(14);
          
              const nameX = logoX + logoSize + 5;
              const nameY = 18;
              const nameMaxWidth = pageWidth - nameX - 15;
          
              const companyNameText = doc.splitTextToSize(
                (company?.name || "COMPANY NAME").toUpperCase(),
                nameMaxWidth,
              );
          
              doc.text(companyNameText, nameX, nameY);
          
              // Calculate Y after company name
              let currentY = nameY + companyNameText.length * 6;
          
              // ================= COMPANY DETAILS =================
              doc.setFont("helvetica", "normal");
              doc.setFontSize(11);
          
              const detailX = nameX;
              const detailMaxWidth = nameMaxWidth;
          
              // Address
              const addressText = doc.splitTextToSize(
                company?.address || "Company Address",
                detailMaxWidth,
              );
              doc.text(addressText, detailX, currentY);
              currentY += addressText.length * 5;
          
              // Email
              const emailText = doc.splitTextToSize(
                `Email: ${company?.email || "-"}`,
                detailMaxWidth,
              );
              doc.text(emailText, detailX, currentY);
              currentY += emailText.length * 5;
          
              // Phone
              const phoneText = doc.splitTextToSize(
                `Phone: ${company?.contact || "-"}`,
                detailMaxWidth,
              );
              doc.text(phoneText, detailX, currentY);
              currentY += phoneText.length * 5;
          
              // Divider
              doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
          
              // ================= REPORT TITLE =================
              doc.setFont("helvetica", "bold");
              doc.setFontSize(13);
              doc.text("Loan Closer Report", pageWidth / 2, currentY + 14, {
                align: "center",
              });
          
              const tableColumn = [
                "SN",
                "Customer Name",
                "Account No",
                "Loan Type",
                "Loan Amount",
                "Tenure",
                "Recovery Freq.",
                "Emi Amount",
                "Applied Date",
                "Disbursal Date",
                "First Emi Date",
                "Status",
              ];
          
              const tableRows = currentLoans.map((item, index) => [
                index + 1,
                item?.userName || "N/A",
                item?.loanAccountNumber || "N/A",
                item?.loanType?`Loan (${item?.loanType})`:"N/A",
                item?.loanAmount ? item?.loanAmount : 0,
                item?.loanTenure ? item?.loanTenure : "N/A",
                item?.loanRecoveryFrequency ? item?.loanRecoveryFrequency : "N/A",
                item.loanEmiAmount ? item.loanEmiAmount : 0,
                item.loanAppliedDate ? new Date(item.loanAppliedDate).toLocaleDateString("en-GB") : "N/A",
                item.disbursalDate ? new Date(item.disbursalDate).toLocaleDateString("en-GB") : "N/A",
                item.firstEmiDate ? new Date(item.firstEmiDate).toLocaleDateString("en-GB") : "N/A",
                item.status || "N/A",
              ]);
          
              autoTable(doc, {
                startY: currentY + 20,
                head: [tableColumn],
                body: tableRows,
          
                theme: "grid",
                styles: {
                  fontSize: 7,
                  cellPadding: 3,
                  halign: "center",
                },
                headStyles: {
                  fontStyle: "bold",
                  fontSize: 7,
                },
                alternateRowStyles: {
                  fillColor: [245, 245, 245],
                },
          
                didDrawPage: function () {
                  const pageWidth = doc.internal.pageSize.width;
                  const pageHeight = doc.internal.pageSize.height;
          
                  doc.setDrawColor(0);
                  doc.setLineWidth(0.2);
          
                  // Page border on EVERY page
                  doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
                },
              });
          
              // ================= FOOTER =================
              const pageCount = doc.internal.getNumberOfPages();
              for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.setTextColor(100);
                doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
                doc.text("Generated by Loan System", 14, pageHeight - 10);
              }
          
              doc.save("LoanCloser_Report.pdf");
            };
          
            const exportExcel = () => {
              const data = currentLoans.map((item) => ({
                "Customer Name": item?.userName || "N/A",
                "Account No": item?.loanAccountNumber || "N/A",
                "Loan Type": item?.loanType?`Loan (${item?.loanType})`:"N/A",
                "Loan Amount": item?.loanAmount
                  ? item?.loanAmount
                  : 0,
                "Loan Tenure": item?.loanTenure ? item?.loanTenure : "N/A",
                "Recovery Frequency": item?.loanRecoveryFrequency ? item?.loanRecoveryFrequency : "N/A",
                "Emi Amount": item.loanEmiAmount ? item.loanEmiAmount : 0,
                "Applied Date": item.loanAppliedDate
                  ? new Date(item.loanAppliedDate).toLocaleDateString("en-GB")
                  : "N/A",
                "Disbursal Date": item.disbursalDate
                  ? new Date(item.disbursalDate).toLocaleDateString("en-GB")
                  : "N/A",
                "First Emi Date": item?.firstEmiDate
                  ? new Date(item?.firstEmiDate).toLocaleDateString("en-GB")
                  : "N/A",
              Status: item.status || "N/A",
              }));
          
              const worksheet = XLSX.utils.json_to_sheet(data);
          
              // 🔹 Header styling
              const headerCells = Object.keys(data[0]);
              headerCells.forEach((_, index) => {
                const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
                worksheet[cellRef].s = {
                  font: {
                    bold: true,
                    color: { rgb: "FFFFFF" },
                  },
                  fill: {
                    fgColor: { rgb: "1F4E78" },
                  },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                  },
                };
              });
          
              // 🔹 Auto column width
              worksheet["!cols"] = headerCells.map((key) => ({
                wch: Math.max(key.length + 5, 18),
              }));
          
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");
          
              XLSX.writeFile(workbook, "Loan_Report.xlsx");
            };
  

  return (
    <div className="LoanReport-container">
      {/* Filter Section */}
      <section className="LoanReport-filterSection">
        <h2 className="LoanReport-title">Closed Loan Report Filter</h2>
        <p className="LoanReport-subtitle">
          Use filter to see more precise closed loan reports
        </p>
        <form className="LoanReport-form" onSubmit={handleSubmit}>
          <div className="LoanReport-grid">
            <div className="LoanReport-formGroup">
              <label>Loan Account Number</label>
              <input
                type="text"
                name="loanAccountNumber"
                placeholder="Loan account number"
                onChange={handleChange}
              />
            </div>
            <div className="LoanReport-formGroup">
              <label>Applicant User ID</label>
              <input
                type="text"
                name="userId"
                placeholder="Applicant user id"
                onChange={handleChange}
              />
            </div>
            <div className="LoanReport-formGroup">
              <label>Applicant User Name</label>
              <input
                type="text"
                name="userName"
                placeholder="Applicant user name"
                onChange={handleChange}
              />
            </div>
          </div>
          <button type="submit" className="LoanReport-submitBtn">
            Submit
          </button>
        </form>
      </section>

      {/* Loan Details Section */}
      <section className="LoanReport-detailsSection">
        <div className="LoanReport-tableHeader">
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
  {ITEMS_PER_PAGE_OPTIONS.map((count) => (
    <option key={count} value={count}>
      {count}
    </option>
  ))}
</select>
            <span> entries</span>
          </div>

          {/* Status filter */}
          <div>
            <label>Loan Status: </label>
            <select
              value={tableStatusFilter}
              onChange={(e) => {
                setTableStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="closed">Closed</option>
              <option value="requested">Requested</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
        </div>
        {currentLoans.length > 0 && (
                    <div
                      className=""
                      style={{ display: "flex", gap: "5px", marginTop: "10px" }}
                    >
                      <button
                        className="collection-report-filter-btn"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        onClick={exportExcel}
                      >
                        <FileTextIcon size={18} /> Excel
                      </button>
                      <button
                        className="collection-report-filter-btn"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        onClick={handleDownloadPDF}
                      >
                        <Download size={18} /> PDF
                      </button>
                    </div>
                  )}
      </div>

        <div className="LoanReport-tableContainer">
          <table className="LoanReport-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan ID</th>
                <th>Borrower Name</th>
                <th>Loan Amount</th>
                <th>Interest Amount</th>
                <th>Loan Tenure</th>
                <th>Loan Frequency</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>Disbursal Date</th>
                <th>Loan Status</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Loan Type</th>
                <th>Verify</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="15">Error: {error}</td>
                </tr>
              ) : currentLoans.length === 0 ? (
                <tr>
                  <td colSpan="15">No closed loans found</td>
                </tr>
              ) : (
                currentLoans.map((loan, index) => (
                  <tr key={loan?.id || index}>
                    <td>{startIndex + index + 1}</td>
                    <td>{loan?.loanAccountNumber || "N/A"}</td>
                    <td>{loan?.userName || "N/A"}</td>
                    <td>{loan?.loanAmount ?? "N/A"}</td>
                    <td>{loan?.loanInterest ?? "N/A"}</td>
                    <td>{loan?.loanTenure ?? "N/A"}</td>
                    <td>{loan?.loanRecoveryFrequency || "N/A"}</td>
                    <td>{new Date(loan?.loanAppliedDate).toLocaleDateString('en-GB') || "N/A"}</td>
                    <td>{new Date(loan?.firstEmiDate).toLocaleDateString("en-GB") || "N/A"}</td>
                    <td>{new Date(loan?.disbursalDate).toLocaleDateString("en-GB") || "N/A"}</td>
                    <td>{loan?.status || "N/A"}</td>
                    <td>{loan?.loanEmiAmount ?? "N/A"}</td>
                    <td>{loan?.loanPayable ?? "N/A"}</td>
                    <td>{loan?.loanType || "N/A"}</td>
                    <td>
                      {/* Navigate to LoanClosureVerify page instead of modal */}
                      <button
                        onClick={() =>
                          navigate(`/LoanClosureVerify/${loan?.id}`, {
                            state: { loan },
                          })
                        }
                      >
                        Verify
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="LoanReport-pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
        )}
      </section>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default LoanClosureReport;